
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IBlogListPayload, IBlogPayload, IDeleteDataResponseAndPayload } from '@src/types/api/blog';


export async function saveBlog(data: IBlogPayload): Promise<AxiosResponse<TResponse<IBlogPayload>>> {
    return axios.post<TResponse<IBlogPayload>>(API_ENDPOINTS.BLOG_SAVE, data)
}

export async function listBlog(qData: QData): Promise<AxiosResponse<TResponseWithQData<IBlogListPayload[]>>> {
    return axios.get(API_ENDPOINTS.BLOG_LIST, {
        params: qData
    })
}

export async function deleteBlog(data: IDeleteDataResponseAndPayload): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
    return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.BLOG_DELETE, data)
}

export async function toggleStatus(data: IDeleteDataResponseAndPayload): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
    return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.BLOG_STATUS, data)
}

export async function blogDetail(_id: string): Promise<AxiosResponse<TResponse<IBlogPayload>>> {
    return axios.get<TResponse<IBlogPayload>>(`${API_ENDPOINTS.BLOG_DETAILS}/${_id}`);
}

